<template>
<div>
    <div class="card">
        <div class="card-body p-5">
            <form>
                <div class="form-group">
                    <label class="form-label">{{$t('label.credit')}}</label>
                    <div class="input-group bg-white shadow-inset-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-right-0">
                                <i class="fal fa-money-check-alt"></i>
                            </span>
                        </div>
                        <input class="form-control pl-3" type="number" :placeholder="$t('label.credit')" step="any" v-model="credit" :min="0" :max="1000" @keypress="isNumber($event)"/>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label">{{$t('label.point')}}</label>
                    <div class="input-group bg-white shadow-inset-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent border-right-0">
                                <i class="fas fa-hand-holding-usd"></i>
                            </span>
                        </div>
                        <input class="form-control pl-3" type="number" :placeholder="$t('label.point')" v-model="point" :min="0" :max="1000" @keypress="isNumber($event)"/>
                    </div>
                </div>
                <div class="row align-items-end" :class="[serviceRow.length == 0 ? ['border-bottom', 'mb-5'] : '']">
                    <div class="col-md-6">
                        <h4 class="mb-0">{{$t('subMenu.salon_menu_service')}}</h4>
                    </div>
                    <div class="col-md-6 text-right">
                        <button v-if="serviceRow.length == 0" class="btn buttons-csv buttons-html5 btn-outline-primary mb-1 mr-3" type="button" @click="addServiceRow()">
                            <span class="fal fa-plus mr-2"></span>
                            <span>{{$t('button_link.add') + $t('subMenu.salon_menu_service')}}</span>
                        </button>
                        <router-link class="btn buttons-csv buttons-html5 btn-outline-primary" :to="'/dashboard/salon_menu_service'" >
                            <span class="fal fa-plus mr-2"></span>
                            <span>{{$t('button_link.create') + $t('subMenu.salon_menu_service')}}</span>
                        </router-link>
                    </div>
                </div>
                <div id="serviceRow">
                    <div class="row" v-for="row in serviceRow" :key="row.count" :id="'serviceRow_' + row.count" :style=" row.count & 1 ? {'background' : '#f9f9f9'} : ''">
                        <div class="col-11">
                            <packageServiceItem ref="packageServiceItem" :rowID="row.count" :serviceItems="row.item"></packageServiceItem>
                        </div>
                        <div class="col-1 d-flex align-items-center">
                            <div class="row">
                                <div class="col-md-6 pl-0">
                                    <a class="link d-block" :title="$t('button_link.add') + $t('subMenu.salon_menu_service')" @click="addServiceRow">
                                        <i class="fas fa-2x fa-plus-circle text-success"></i>
                                    </a>
                                </div>
                                <div class="col-md-6 pl-0">
                                    <a class="link" :title="$t('button_link.remove') + $t('subMenu.salon_menu_service')" @click="removeServiceRow">
                                        <i class="fas fa-2x fa-trash text-danger"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-end">
                    <div class="col-md-6">
                        <h4 class="mb-0">{{$t('subMenu.salon_menu_product')}}</h4>
                    </div>
                    <div class="col-md-6 text-right">
                        <button v-if="productRow.length == 0" class="btn buttons-csv buttons-html5 btn-outline-primary mb-1 mr-3" type="button" @click="addProductRow()">
                            <span class="fal fa-plus mr-2"></span>
                            <span>{{$t('button_link.add') + $t('subMenu.salon_menu_product')}}</span>
                        </button>
                        <router-link class="btn buttons-csv buttons-html5 btn-outline-primary" :to="'/dashboard/salon_menu_product'">
                            <span class="fal fa-plus mr-2"></span>
                            <span>{{$t('button_link.create') + $t('subMenu.salon_menu_product')}}</span>
                        </router-link>
                    </div>
                </div>
                <div id="productRow">
                    <div class="row" v-for="row in productRow" :key="row.count" :id="'productRow_' + row.count" :style=" row.count & 1 ? {'background' : '#f9f9f9'} : ''">
                        <div class="col-11">
                            <packageProductItem ref="packageProductItem" :rowID="row.count" :productItems="row.item"></packageProductItem>
                        </div>
                        <div class="col-1 d-flex align-items-center">
                            <div class="row">
                                <div class="col-md-6 pl-0">
                                    <a class="link d-block" :title="$t('button_link.add') + $t('subMenu.salon_menu_product')" @click="addProductRow">
                                        <i class="fas fa-2x fa-plus-circle text-success"></i>
                                    </a>
                                </div>
                                <div class="col-md-6 pl-0">
                                    <a class="link" :title="$t('button_link.remove') + $t('subMenu.salon_menu_product')" @click="removeProductRow">
                                        <i class="fas fa-2x fa-trash text-danger"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mb-2 mr-3" @click="returnPackageList">{{$t('button_link.cancel')}}</button>
                        <button type="button" class="btn border-0 btn-dark btn-padding waves-effect waves-themed mb-2 mr-3" @click="returnPreviousStep">{{$t('button_link.prev')}}</button>
                        <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed mb-2" @click="submitPackageItem">{{$t('button_link.next')}}</button>
                    </div>
                    <div class="d-none col-6 text-right">
                        <button v-if="isEdit" type="button" class="btn border-0 btn-danger btn-padding waves-effect waves-themed" @click="disablePackage">Disable</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import PackageServiceItem from './Package_Add_Service'
import PackageProductItem from './Package_Add_Product'
import {isNumber} from './../../../../assets/js/dashboard/utilities'
export default {
    name: 'packageItems',
    components:{
        PackageServiceItem, PackageProductItem
    },
    props: {
        isEdit: { type: Boolean }
    },
    data(){
        return{
            step: 2,
            serviceRow: [{count: 0, item: {}}], serviceCount: 0, isAddService: false,
            productRow:[{count: 0, item: {}}], productCount: 0, isAddProduct: false,
            credit: 0, point: 0,
            result: {}, packageItems: []
        }
    },
    methods:{
        isNumber(e){
            return isNumber(e);
        },
        submitPackageItem(){
            this.result["package"] = this.getPackageItems();
            this.$emit('submitPackageItem', this.step, this.result);
        },
        returnPreviousStep(){
            this.$emit('returnPreviousStep', this.step);
        }, 
        returnPackageList(){
            this.$emit('returnPackageList');
        },
        addServiceRow(){
            this.isAddService = true;
            this.serviceRow.push({count: this.isEdit ? this.serviceCount++ : ++this.serviceCount, item: {}});
        },
        removeServiceRow(){
            this.serviceRow.pop();
            this.serviceCount--
        },
        addProductRow(){
            this.isAddProduct = true;
            this.productRow.push({count: this.isEdit ? this.productCount++ : ++this.productCount, item: {}});
        },
        removeProductRow(){
            this.productRow.pop();
            this.productCount--
        },
        getPackageItems(){
            var result = {};
            this.packageItems = [];
            for(var i=0; i<this.serviceRow.length; i++){
                var itemObj = this.$refs.packageServiceItem[i].getPackageServiceItem();
                if(itemObj.itemID != 0){
                    this.packageItems.push(itemObj);
                }
            }

            for(var j=0; j<this.productRow.length; j++){
                var itmObj = this.$refs.packageProductItem[j].getPackageProductItem();
                if(itmObj.itemID != 0){
                    this.packageItems.push(itmObj);
                } 
                
            }
            result["items"] = this.packageItems;
            result["credits"] = this.credit;
            result["points"] = this.point;
            return result;
        }, 
        editPackageItems(items){
            this.serviceRow = []; this.serviceCount = 0;
            this.productRow = []; this.productCount = 0;
            
            this.credit = parseFloat(items.package.credits);
            this.point = parseInt(items.package.points);

            this.packageItems = items.package.items;
            for(var i=0; i<this.packageItems.length; i++){
                if(this.packageItems[i].type == "service"){
                    this.serviceRow.push({count: this.serviceCount, item: this.packageItems[i]})
                    this.serviceCount++
                }else{
                    this.productRow.push({count: this.productCount, item: this.packageItems[i]});
                    this.productCount++
                }
            }                       
        }, 
        disablePackage(){
            this.result["isEnable"] = 0
            this.$emit('disablePackage', this.result)
        },
    },
    updated(){
        let $vm = this;
        if($vm.isAddService){
            var lastServiceRow =  document.getElementById('serviceRow').lastChild
            lastServiceRow.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            $vm.isAddService = false;
        } 
        
        if($vm.isAddProduct){
            var lastProductRow =  document.getElementById('productRow').lastChild
            lastProductRow.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            $vm.isAddProduct = false;
        } 
        
    }
}
</script>

